<template lang="pug">
.compensacao-table
    grid-table-component(:headers='headerTacDecJudiciaisTcras', :data='tacDecisoesJudiciaisTcras', :is-paginated='false')
        template(v-slot:aprovado='{ item }')
            validacao-component(
                :id='item.tipo + "radioselect"'
                :tipo='item.tipo',
                :item='item',
                :tipos-documentos='tiposDocumentos',
                @validacao='validar(item, $event)'
            )

        template(v-slot:acao='{ item }')
            dropdown-component(
                :list='item.acao'
                @input="onAction($event, item)"
                :is-select='false'
                position='left'
            )
    modal-component(
        v-if='analiseModalFlag',
        :title='selectedEtapa.tipo + " documentos"',
        @close='analiseModalFlag = false'
        width='35rem'
    )
        AnaliseModalDocumentos(:etapa='selectedEtapa')

    modal-component(
        v-if='exibirMapa',
        title='Mapa',
        @close='exibirMapa = false',
        width='95%'
    )
        #mapa-iara
            mapa-geo-car-wc(
                ref='_infoMapa'
                :id-imovel="$route.params.codigoImovelCriptografado",
                :sicar-url='urlSicar',
                :token='token',
                @loadded="handleMapaCarregado"
            )
</template>

<script>
import AnaliseModalDocumentos from '@/views/analise/components/AnaliseModalDocumentos.vue';
import ValidacaoComponent from '@/views/analise/components/ValidacaoComponent.vue';
import Mapa from '@/components/standard/Mapa.vue';
import { obterGeometrias } from '@/services/etapa-geometria.service';

export default {

    name: 'IaraTacDecJudiciaisTcrasTable',

    components: {
        AnaliseModalDocumentos,
        ValidacaoComponent,
        Mapa
    },

    props: {
        tacDecisoesJudiciaisTcras: {
            type: Array,
            required: true,
        },

        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            headerTacDecJudiciaisTcras: [
                { text: 'Tipo', field: 'tipo' },
                { text: 'Tempo de recomposição (anos)', field: 'tempoRecomposicao' },
                { text: 'Ação', field: 'acao' },
                { text: 'Avaliação', field: 'aprovado' },
            ],

            aprovadoOptions: [
                { id: 1, label: 'Aprovado', isChecked: false },
                { id: 2, label: 'Reprovado', isChecked: false },
            ],

            selectedEtapa: null,
            analiseModalFlag: false,
            exibirMapa: false,
            geometrias: [],
            token: null,
            urlSicar: process.env.VUE_APP_SICAR_URL,
        };
    },

    mounted() {
        if (this.$route.params?.aderiuPra) {
            this.token = process.env.VUE_APP_TOKEN_MAPA_SICAR_COM_PRA;
        } else {
            this.token = process.env.VUE_APP_TOKEN_MAPA_SICAR_SEM_PRA;
        }
    },

    methods: {

        modalDocumentos(item) {
            this.selectedEtapa = item;
            this.analiseModalFlag = true;
        },

        validar(item, validacao) {
            this.$emit('itemValidados', { key: 'TAC_DEC_JUDICIAIS', data: this.tacDecisoesJudiciaisTcras, validacao });
        },

        onAction(event, item) {
            if (event.id === 'DOC') {
                this.modalDocumentos(item);
            } else if (event.id === 'MAP') {
                this.buscarGeometria(item);
            }
        },

        async buscarGeometria(item) {
            if (item.geometrias.length > 0) {
                const geometriaIds = item.geometrias.map(geo => geo.id);
                this.geometrias = await obterGeometrias(geometriaIds);
            }
            this.geometrias.tipo = item.tipo;
            this.exibirMapa = true;
        },

        handleMapaCarregado() {
            this.geometrias.forEach((area) => {
                setTimeout(() => {
                    this.$refs._infoMapa._wrapper.$refs.inner.addGeoJsonToDrawnItems(
                        area,
                        { color: 'red' },
                        { labelArea: this.geometrias.tipo, exibirOrdemArea: false }
                    );
                }, 500);
            });
        }
    },
};
</script>

<style >
.radio-position {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
}

#mapa-iara {
    height: calc(100vh - 100px);
}
</style>
